import { render } from "./Number.vue?vue&type=template&id=8c365de0&scoped=true&ts=true"
import script from "./Number.vue?vue&type=script&lang=ts"
export * from "./Number.vue?vue&type=script&lang=ts"

import "./Number.vue?vue&type=style&index=0&id=8c365de0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c365de0"]])

export default __exports__